module.exports = __webpack_public_path__ + "img/symbol_10.72b8eb70.png";